import React from 'react'
import Translation from '../General/Translation'
import { MULTICINEMA } from '../constants/multiCinemaModes'
import CinemaButton from './CinemaButton'

const getSortedCinemasObjects = (cinemaPk, cinemas) => {
    const sortedTheatres = cinemaPk.sort(function(a, b) {
        const cinemaA = cinemas[a]
        const cinemaB = cinemas[b]

        const aName = cinemaA.nameDisplay
        const bName = cinemaB.nameDisplay
        
        return bName > aName ? -1 : bName < aName ? 1 : 0
    })

    return sortedTheatres
}


const PerformancePerCinemaFilters = ({
    activeCinema,
    clusterCinemaOption,
    clusterCinemaName,
    clusterCinemas,
    currentCinemaType,
    cinemas,
    currentCinemaPk,
    setActiveCinema, 
    translation}) => {
        if(!clusterCinemaOption && currentCinemaType !== MULTICINEMA) {
            return ''
        }
    
        if(clusterCinemaOption) {
            const sortedCinemas = getSortedCinemasObjects(clusterCinemas, cinemas)
            const activeClassClusterCinema = activeCinema === currentCinemaPk ? ' active' : ' button-reverse'
            
            return <div className='performance-per-cinema-filter-buttons-container'>
                {clusterCinemaName && <div className={'performance-per-cinema-filter-button'}><button className={'button buttons-border cinema-filter' + activeClassClusterCinema} onClick={() => setActiveCinema(currentCinemaPk)}>{clusterCinemaName}</button></div>}
                {clusterCinemas && sortedCinemas.map((currentCinemaPk, index) => {
                    const cinema = cinemas[currentCinemaPk]
                    const activeClass = activeCinema === currentCinemaPk ? ' active' : ' button-reverse'

                    return cinema && <CinemaButton key={index} cinema={cinema} activeClass={activeClass} activeCinema={activeCinema} setActiveCinema={setActiveCinema} />
                })}
            </div>
        } else {
            const sortedCinemas = getSortedCinemasObjects(_.keys(cinemas), cinemas)
            
            return <div className='performance-per-cinema-filter-buttons-container'>
                {sortedCinemas && sortedCinemas.map((currentCinemaPk, index) => {
                    const cinema = cinemas[currentCinemaPk]
                    const isMultiCinema = cinema.scope.type === MULTICINEMA ? true : false
                    const activeClass = activeCinema === currentCinemaPk ? ' active' : ' button-reverse'

                    return isMultiCinema && cinema && <div key={index} className={'performance-per-cinema-filter-button all-cinemas'}><button className={'button buttons-border cinema-filter' + activeClass} onClick={() => setActiveCinema(cinema.pk)}>{<Translation id="selectAllCinemas" trans={translation}>Alle Kinos</Translation>}</button></div>
                })}
                {sortedCinemas && sortedCinemas.map((currentCinemaPk, index) => {
                    const cinema = cinemas[currentCinemaPk]
                    const isMultiCinema = cinema.scope.type === MULTICINEMA ? true : false
                    const activeClass = activeCinema === currentCinemaPk ? ' active' : ' button-reverse'

                    return !isMultiCinema && cinema && <CinemaButton key={index} cinema={cinema} activeClass={activeClass} activeCinema={activeCinema} setActiveCinema={setActiveCinema} />
                })}
            </div>
        }
}

export default PerformancePerCinemaFilters